import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { RefIdChip } from './RefIdChip';

export function ReportUnavailable({
  requestId,
  onRetry,
  className,
  sessionExpired,
}) {
  if (sessionExpired) {
    return (
      <Box
        className={className}
        data-testid="report-unavailable"
        data-variant="session-expired"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        margin="20px"
        padding="24px"
      >
        <Typography
          style={{ fontSize: '22px', fontWeight: 600, marginBottom: '8px' }}
        >
          Your session needs to refresh
        </Typography>
        <Typography
          style={{
            fontSize: '14px',
            color: '#555',
            marginBottom: '16px',
            textAlign: 'center',
            maxWidth: '480px',
          }}
          data-testid="report-unavailable-session-expired-body"
        >
          We couldn&apos;t load this report because your sign-in needs to
          refresh. Try again in a moment to reload it.
        </Typography>
        {onRetry && (
          <Button
            onClick={onRetry}
            variant="contained"
            color="primary"
            data-testid="report-unavailable-retry"
          >
            Try again
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box
      className={className}
      data-testid="report-unavailable"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      margin="20px"
      padding="24px"
    >
      <Typography
        style={{ fontSize: '22px', fontWeight: 600, marginBottom: '8px' }}
      >
        Report unavailable for this restaurant
      </Typography>
      <Typography
        style={{
          fontSize: '14px',
          color: '#555',
          marginBottom: '16px',
          textAlign: 'center',
          maxWidth: '480px',
        }}
      >
        Something went wrong loading this report. Our team has been notified.
        If you contact support, please share the reference id below so they
        can look up the exact request.
      </Typography>
      <RefIdChip
        requestId={requestId}
        testIdPrefix="report-unavailable"
      />
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="text"
          style={{ marginTop: '16px' }}
          data-testid="report-unavailable-retry"
        >
          Try again
        </Button>
      )}
    </Box>
  );
}

ReportUnavailable.propTypes = {
  requestId: PropTypes.string,
  onRetry: PropTypes.func,
  className: PropTypes.string,
  sessionExpired: PropTypes.bool,
};

ReportUnavailable.defaultProps = {
  requestId: null,
  onRetry: null,
  className: undefined,
  sessionExpired: false,
};

export default ReportUnavailable;
